import { render } from "./AudienceEditForm.vue?vue&type=template&id=2dc336c2"
import script from "./AudienceEditForm.vue?vue&type=script&lang=js"
export * from "./AudienceEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__